export default {
  state: {
    minorItems: [
      {
        type: "smallMissiles",
        name: "Missiles + 2",
        amount: 2,
        total: 15,
        startAmount: 15,
      },
      {
        type: "bigMissiles",
        name: "Missiles + 10",
        amount: 10,
        startAmount: 15,
      },
      {
        type: "energyPart",
        name: "Energy Part",
        total: 0,
        amount: 1,
        startAmount: 0,
      },
      {
        type: "energyFull",
        name: "Energy Full",
        total: 0,
        amount: 1,
        startAmount: 0,
      },
      {
        type: "smallPowerBomb",
        name: "Powerbomb + 1",
        total: 0,
        amount: 1,
        startAmount: 0,
      },
    ],
    items: [
      {
        type: "morphBall",
        name: "Morph Ball",
        checked: false,
        logic: false,
      },
      {
        type: "slide",
        name: "Slide",
        checked: true,
        logic: true,
      },

      {
        type: "bomb",
        name: "Bomb",
        checked: false,
        logic: false,
      },
      {
        type: "crossBomb",
        name: "Cross Bomb",
        checked: false,
        logic: false,
      },
      {
        type: "powerBomb",
        name: "Main Power Bomb",
        checked: false,
        logic: false,
      },
      {
        type: "chargeBeam",
        name: "Charge Beam",
        checked: false,
        logic: false,
      },
      {
        type: "diffusionBeam",
        name: "Diffusion Beam",
        checked: false,
        logic: false,
      },
      {
        type: "variaSuit",
        name: "Varia Suit",
        checked: false,
        logic: false,
      },
      {
        type: "gravitySuit",
        name: "Gravity Suit",
        checked: false,
        logic: false,
      },
      {
        type: "spiderMagnet",
        name: "Spider Magnet",
        checked: false,
        logic: false,
      },
      {
        type: "grappleBeam",
        name: "Grapple Beam",
        checked: false,
        logic: false,
      },
      {
        type: "phantomCloak",
        name: "Phantom Cloak",
        checked: false,
        logic: false,
      },
      {
        type: "flashShift",
        name: "Flash Shift",
        checked: false,
        logic: false,
      },
      {
        type: "pulseRadar",
        name: "Pulse Radar",
        checked: false,
        logic: false,
      },
      {
        type: "wideBeam",
        name: "Wide Beam",
        checked: false,
        logic: false,
      },
      {
        type: "plasmaBeam",
        name: "Plasma Beam",
        checked: false,
        logic: false,
      },
      {
        type: "waveBeam",
        name: "Wave Beam",
        checked: false,
        logic: false,
      },
      {
        type: "speedBooster",
        name: "Speed Booster",
        checked: false,
        logic: false,
      },

      {
        type: "superMissiles",
        name: "Super Missiles",
        checked: false,
        logic: false,
      },

      {
        type: "iceMissiles",
        name: "Ice Missiles",
        checked: false,
        logic: false,
      },
      {
        type: "stormMissiles",
        name: "Storm Missiles",
        checked: false,
        logic: false,
      },

      {
        type: "spinBoost",
        name: "Spin Boost",
        checked: false,
        logic: false,
      },

      {
        type: "spaceJump",
        name: "Space Jump",
        checked: false,
        logic: false,
      },
      {
        type: "screwAttack",
        name: "Screw Attack",
        checked: false,
        logic: false,
      },
    ],
    metroidDna: [
      { type: "metroidDna1", name: "Metroid DNA 1", checked: false },
      { type: "metroidDna2", name: "Metroid DNA 2", checked: false },
      { type: "metroidDna3", name: "Metroid DNA 3", checked: false },
      { type: "metroidDna4", name: "Metroid DNA 4", checked: false },
      { type: "metroidDna5", name: "Metroid DNA 5", checked: false },
      { type: "metroidDna6", name: "Metroid DNA 6", checked: false },
      { type: "metroidDna7", name: "Metroid DNA 7", checked: false },
      { type: "metroidDna8", name: "Metroid DNA 8", checked: false },
      { type: "metroidDna9", name: "Metroid DNA 9", checked: false },
      { type: "metroidDna10", name: "Metroid DNA 10", checked: false },
      { type: "metroidDna11", name: "Metroid DNA 11", checked: false },
      { type: "metroidDna12", name: "Metroid DNA 12", checked: false },
    ],

    progressiveLogic: [
      {
        type: "progressiveBomb",
        logic: false,
      },
      {
        type: "progressiveBeam",
        logic: false,
      },
      {
        type: "progressiveCharge",
        logic: false,
      },
      {
        type: "progressiveSuit",
        logic: false,
      },
      {
        type: "progressiveJump",
        logic: false,
      },
      {
        type: "movement",
        logic: false,
      },
      {
        type: "health",
        amount: 99,
        logic: false,
      },
    ],
  },
  mutations: {
    UPDATE_AREA(state, index) {
      state.items[index].logic = !state.items[index].logic;
    },
    /**
     * Set-by-value hydration for restore (PER-01/PER-02).
     * Accepts a checkedItems map { [type]: boolean }.
     * ABSOLUTE-SET semantics — does NOT toggle; safe to call from restoreState.
     * Mirrors logic ← checked so the engine (which reads items[].logic) sees the
     * restored inventory; recompute does NOT re-derive logic from checked.
     * Note: the vestigial Release-the-X flag has been removed (LOG-03).
     */
    HYDRATE_ITEMS(state, { checkedItems }) {
      const map = checkedItems || {};
      for (const item of state.items) {
        if (Object.prototype.hasOwnProperty.call(map, item.type)) {
          item.checked = map[item.type] === true;
        } else {
          item.checked = false;
        }
        item.logic = item.checked;
      }
    },
    /**
     * Reset all items to unchecked/unlogic state (for resetProgress).
     * Retains static display data (name/type).
     * Slide and pulseRadar checked/logic derive from startingItems (SET-08) rather
     * than being hardcoded — pass the configured startingItems so the reset reflects
     * the actual preset (defaults: Slide=1, Pulse=1 in Dread starter preset).
     * Also clears all 12 Metroid DNA toggles.
     * Note: the vestigial Release-the-X flag has been removed (LOG-03).
     *
     * @param {object} startingItems - e.g. { Slide: 1, Pulse: 1, MissileLauncher: 1, ... }
     *   If null/undefined, falls back to Dread defaults (Slide on, Pulse off).
     */
    RESET_ITEMS(state, startingItems) {
      const si = startingItems || {};
      // Derive slide/pulse from startingItems; all other abilities start unchecked.
      // startingItems uses Randovania short-names (Slide, Pulse); tracker types are
      // "slide" and "pulseRadar". The mapping: Slide → "slide", Pulse → "pulseRadar".
      const slideOn = si.Slide !== undefined ? si.Slide === 1 : true; // Dread starter default
      const pulseOn = si.Pulse !== undefined ? si.Pulse === 1 : false;
      for (const item of state.items) {
        if (item.type === "slide") {
          item.checked = slideOn;
          item.logic = slideOn;
        } else if (item.type === "pulseRadar") {
          item.checked = pulseOn;
          item.logic = pulseOn;
        } else {
          item.checked = false;
          item.logic = false;
        }
      }
      for (const entry of state.metroidDna) {
        entry.checked = false;
      }
    },
    /**
     * Flip checked state of one DNA entry (display-only — no logic/engine side-effect).
     * @param {string} type - "metroidDna1" | "metroidDna2" | "metroidDna3"
     */
    TOGGLE_DNA(state, type) {
      const entry = state.metroidDna.find((e) => e.type === type);
      if (entry) {
        entry.checked = !entry.checked;
      }
    },
    /**
     * Absolute-set hydration for DNA from the shared checkedItems persistence map.
     * Absent keys default to false. Mirror of HYDRATE_ITEMS semantics.
     * @param {object} checkedItems - { [type]: boolean } map from blob
     */
    HYDRATE_DNA(state, checkedItems) {
      const map = checkedItems || {};
      for (const entry of state.metroidDna) {
        entry.checked = map[entry.type] === true;
      }
    },
    UPDATE_PROGRESSIVE(state, index) {
      if (index) {
        state.progressiveLogic[index] = true;
      }
    },
    SET_MISSILES(state, { amount }) {
      state.minorItems[0].total += amount;
    },
    SET_ABILITY(state, { index, amount }) {
      state.minorItems[index].total += amount;
    },
    ROTATE_ENERGY(state) {
      state.minorItems[2].total = 0;
    },
    FIX_ENERGY(state) {
      state.minorItems[2].total += 3;
      // state.minorItems[3].total -= 1;
    },
    PREVENT_NEGATIVE(state, index) {
      state.minorItems[index].total = state.minorItems[index].startAmount;
    },
  },
  actions: {
    /**
     * Toggle a Metroid DNA tracker checkbox and recompute in-logic pickups (LOG-01/LOG-04).
     * DNA now affects reachability via Artifact injection in buildResourceState: collecting
     * enough DNA opens the Itorash Artifact Gate, making Ship reachable.
     * @param {{ type: string }} payload - e.g. { type: "metroidDna1" }
     */
    toggleDna({ commit, dispatch }, { type }) {
      commit("TOGGLE_DNA", type);
      dispatch("logic/recompute", null, { root: true });
    },
    updateArea({ commit, dispatch }, { index }) {
      commit("UPDATE_AREA", index);
      dispatch("logic/recompute", null, { root: true });
    },
    checkProgressive({ commit, state }) {
      let index = null;
      if (state.items[0].checked) {
        index = 0;
      }
      commit("UPDATE_PROGRESSIVE", index);
    },
    updateMinor({ commit, state }, { index, amount }) {
      if (
        state.minorItems[index].type === "smallMissiles" ||
        state.minorItems[index].type === "bigMissiles"
      ) {
        let total = state.minorItems[0].total + amount;
        if (state.minorItems[0].startAmount >= total) {
          commit("PREVENT_NEGATIVE", 0);
          amount = 0;
        }
        commit("SET_MISSILES", { amount });
      } else {
        if (state.minorItems[index].type === "energyPart") {
          let result = state.minorItems[2].total + amount;
          if (result === 4) {
            index = 3;
            commit("ROTATE_ENERGY");
          } else if (result === -1) {
            if (state.minorItems[3].total > 0) {
              commit("FIX_ENERGY");
              index = 3;
            }
          }
        }
        if (
          state.minorItems[index].total <=
            state.minorItems[index].startAmount &&
          amount < 0
        ) {
          commit("PREVENT_NEGATIVE", index);
          amount = 0;
        }
        commit("SET_ABILITY", { index, amount });
      }
    },
  },
  getters: {
    inLogic(state) {
      return state.items;
    },
    metroidDna(state) {
      return state.metroidDna;
    },
  },
  namespaced: true,
};
